module.exports = __webpack_public_path__ + "img/icon-link.71cd3d9c.svg";